import { create } from "zustand"
import { createJSONStorage, devtools, persist } from "zustand/middleware"

interface ICallCaseSummaryFeedbackStore {
  hasUsedByAppointment: Record<string, boolean>
  markUsed: (appointmentId: string) => void
}

const useCallCaseSummaryFeedbackStore = create<ICallCaseSummaryFeedbackStore>()(
  devtools(
    persist(
      (set) => ({
        hasUsedByAppointment: {},
        markUsed: (appointmentId: string) =>
          set((state) => ({
            hasUsedByAppointment: { ...state.hasUsedByAppointment, [appointmentId]: true },
          })),
      }),
      { name: "callCaseSummaryFeedbackStore", storage: createJSONStorage(() => sessionStorage) },
    ),
  ),
)

export default useCallCaseSummaryFeedbackStore
